<template>
    <v-tabs 
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab key="Campi" ripple class="secondary-tab">
            Campi
        </v-tab>
        <v-tab key="Azioni" ripple class="secondary-tab">
            Azioni
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-offset" key="Campi">
            <v-row class="ma-0 ">
                
                <v-col class="pa-0 pt-2" cols="12">
                    <fields-selector model-def="helpdesktariff"></fields-selector>
                </v-col>

            </v-row>
        </v-tab-item>
        
        <v-tab-item class="background-1 pt-3 pb-offset" key="Azioni">
            <v-row class="ma-0">
                
                <v-col class="pa-0 pt-2" cols="12">
                    <actions-selector model-def="helpdesktariff"></actions-selector>
                </v-col>

            </v-row>
        </v-tab-item>

    </v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'

	export default {
		name:'helpdesktariffs-settings',
        components: {
            FieldsSelector,
            ActionsSelector,
        },		
		data() {
			return {

			}
		},
	}
  </script>
